import React, { Component } from 'react';

// import { API, Auth } from "aws-amplify";

// import { Layout, Menu, Breadcrumb, Icon } from 'antd';
import { Card } from 'antd';
import { PageHeader } from 'antd'; 
// import { Button } from 'antd';

import ClientViewPageComponentContainer from '../../../components/pages/dashboard/clients/ClientViewPageComponent';

// const { Header, Content, Footer, Sider } = Layout;
// const { SubMenu } = Menu;

class ClientViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {

    // console.log(this.props.match.params.client_id)

    return (

      <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
        <PageHeader
          style={{
            paddingLeft: 0,
            borderBottom: '1px solid rgb(235, 237, 240)',
            marginBottom: 16
          }}
          title="View Client"
        />
        <Card
          style={{ minHeight: 360 }}
          title="View details of current client"
        >
          <div style={{ paddingTop: 24 }}>
          <ClientViewPageComponentContainer
            client_id={this.props.match.params.client_id}
           />

          </div>
        </Card>
      </div>


    );
  }
}

export default ClientViewPage;
